<template>
  <v-container>
    <h2>ALARMAS ACTIVAS</h2>
    <v-card
      class="mt-4"
      :color="alarms.length > 0 ? 'red' : '#e6ffe6'"
    >
      <!-- Alarmas activas actualmente -->
      <v-container>
        <v-card v-if="alarms.length > 0">
          <v-data-table
            class="active-alarms"
            sort-by="read_timestamp"
            sort-desc
            :headers="headers_active"
            :items="alarms"
            :footer-props="{
              'items-per-page-text': 'Alarmas por página',
            }"
          >
            <template v-slot:[`item.icon`]="">
              <v-icon color="#db0d0d"> mdi-alert </v-icon>
            </template>
            <template v-slot:[`item.read_timestamp`]="{ item }">
              {{ formatTimestamp(item.read_timestamp) }}
            </template>
            <template v-slot:no-results>
              <span>No hay datos para esta búsqueda</span>
            </template>
          </v-data-table>
        </v-card>
        <v-card v-else>
          <v-card-title class="body-1"> Actualmente no se encuentra ninguna alarma activa </v-card-title>
        </v-card>
      </v-container>
    </v-card>

    <!-- Históricos de alarmas -->

    <h2 class="mt-10">HISTÓRICO DE ALARMAS</h2>
    <v-card
      class="mt-4"
      color="#a7ecff"
    >
      <v-container class="text-center">
        <v-card>
          <v-btn
            class="ma-3"
            @click="toggleHistory"
            >{{ show_history ? "Ocultar" : "Consultar" }} históricos</v-btn
          >
          <template v-if="show_history">
            <div class="ml-0 mb-4 mt-2 pl-3 pr-3">
              <v-row class="justify-center">
                <v-col cols="3">
                  <v-menu
                    v-model="initTimestampInput"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="initTimestamp"
                        label="Fecha inicio"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="initTimestamp"
                      @input="initTimestampInput = false"
                      no-title
                      scrollable
                      first-day-of-week="1"
                      locale="es-ES"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="3">
                  <v-menu
                    v-model="endTimestampInput"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="endTimestamp"
                        label="Fecha fin"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endTimestamp"
                      @input="endTimestampInput = false"
                      no-title
                      scrollable
                      first-day-of-week="1"
                      locale="es-ES"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="3">
                  <v-text-field
                    v-model="description"
                    label="Descripción"
                    type="string"
                    hide-details
                  >
                  </v-text-field>
                </v-col>

                <v-col
                  cols="3"
                  style="align-content: center"
                  class="pb-5"
                >
                  <v-btn
                    @click="getHistory"
                    color="#a7ecff"
                    rounded
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <!-- Tabla de alarmas -->
            <v-data-table
              :headers="headers_history"
              :items="alarm_history"
              :search="search"
              :loading="loading_history"
              no-data-text="No se han encontrado datos"
              :footer-props="{
                'items-per-page-text': 'Alarmas por página',
              }"
            >
              <template v-slot:[`item.activation_timestamp`]="{ item }">
                {{ formatTimestamp(item.activation_timestamp) }}
              </template>
              <template v-slot:[`item.deactivation_timestamp`]="{ item }">
                {{ formatTimestamp(item.deactivation_timestamp) || "ACTUALMENTE ACTIVA" }}
              </template>
              <template v-slot:no-results>
                <span>No hay datos para esta búsqueda</span>
              </template>
            </v-data-table>
          </template>
        </v-card>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import "moment-timezone";

import { mapActions } from "vuex";

export default {
  data() {
    return {
      alarms: [],
      alarm_history: [],

      headers_active: [
        { text: "", value: "icon" },
        { text: "ID", value: "alarm_id" },
        { text: "Descripción", value: "description" },
        { text: "Activado", value: "read_timestamp" },
      ],
      headers_history: [
        { text: "ID", value: "alarm_id" },
        { text: "Descripción", value: "description" },
        { text: "Activado", value: "activation_timestamp" },
        { text: "Desactivado", value: "deactivation_timestamp" },
      ],

      search: null,

      description: "",
      initTimestamp: moment(Date.now()).subtract(1, "days").format("YYYY-MM-DD"),
      endTimestamp: moment(Date.now()).format("YYYY-MM-DD"),
      initTimestampInput: false,
      endTimestampInput: false,

      next_action: "Consultar",
      show_history: false,
      loading_history: false,
    };
  },

  methods: {
    ...mapActions(["getData"]),

    async toggleHistory() {
      this.show_history = !this.show_history;
      if (this.show_history) await this.getHistory();
    },

    formatTimestamp(timestamp) {
      if (timestamp != null && timestamp != undefined && timestamp.length > 0) {
        return moment(timestamp).tz("Europe/Madrid").format("YYYY-MM-DD HH:mm:ss");
      } else return null;
    },

    async getHistory() {
      this.loading_history = true;
      const params = {
        initTimestamp: new Date(`${this.initTimestamp} 00:00:00`).toISOString(),
        endTimestamp: new Date(`${this.endTimestamp} 23:59:59`).toISOString(),
        description: this.description,
      };
      const { alarms } = await this.getData({ path: "alarms/history", params });
      this.alarm_history = alarms;
      this.loading_history = false;
    },
  },

  async mounted() {
    const { alarms } = await this.getData({ path: "alarms" });
    this.alarms = alarms;
  },
};
</script>
